<h1>{{"navigation.about" | translate}}</h1>
<div class="app-row">
    <div class="app-col">
      <img src="assets/img/about1.jpg"/>
    </div>
    <div class="app-col">
      <img src="assets/img/about2.jpg"/>
    </div>
    <div class="app-col">
      <img src="assets/img/about3.jpg"/>
    </div>
  </div>
  <div class="app-row">
    <div class="app-col">
        <h1>{{"home.about.section1.title" | translate}}</h1>
        {{"home.about.section1.text" | translate}}
    </div>
    <div class="app-col">
        <h1>{{"home.about.section2.title" | translate}}</h1>
        <div [innerHtml]="getSection2Text() | async"></div>
    </div>
    <div class="app-col">
        <h1>{{"home.about.section3.title" | translate}}</h1>
        <div [innerHtml]="getSection3Text() | async"></div>
    </div>
  </div>